<script setup>
import Faq from './Components/Faq.vue';
import Subfooter from './Includes/Subfooter.vue';
import { Head, useForm, router } from "@inertiajs/vue3";

import Input from './Components/Form/Input.vue';
import Select from './Components/Form/Select.vue';
import Textarea from './Components/Form/Textarea.vue';
import Checkbox from './Components/Form/Checkbox.vue';
import SaveButton from './Components/Form/SaveButton.vue';

import { ref, onMounted, watch } from "vue";
import Button from './Components/Button.vue';

const subjects = [
    { id: 'algemeen', label: 'Algemeen' },
    { id: 'verkoop', label: 'Verkoop' },
    { id: 'service', label: 'Service' },
    { id: 'proefrit', label: 'Proefrit' },
    { id: 'overig', label: 'Overig' },
]

const brands = [
    { id: 'audi', label: 'Audi', href: "/aanbod?merk=Audi", src: "/img/car_logos/audi.svg" },
    { id: 'bmw', label: 'BMW', href: "/aanbod?merk=BMW", src: "/img/car_logos/bmw.svg" },
    { id: 'citroen', label: 'Citroën', href: "/aanbod?merk=Citroën", src: "/img/car_logos/citroen.svg" },
    { id: 'mercedes', label: 'Mercedes-Benz', href: "/aanbod?merk=Mercedes-Benz", src: "/img/car_logos/mercedes.svg" },
    { id: 'peugeot', label: 'Peugeot', href: "/aanbod?merk=Peugeot", src: "/img/car_logos/peugeot.avif" },
    { id: 'volkswagen', label: 'Volkswagen', href: "/aanbod?merk=Volkswagen", src: "/img/car_logos/volkswagen.svg" },
]
const limitedBrands = ref([]);
const visibleBrands = ref([]);

onMounted(() => {
    limitedBrands.value = brands.sort(() => 0.5 - Math.random());
    updateVisibleBrands();
    window.addEventListener('resize', updateVisibleBrands);
});

watch(limitedBrands, updateVisibleBrands);

function updateVisibleBrands() {
    const width = window.innerWidth;
    let itemsToShow;

    if (width < 310) {
        itemsToShow = 2;
    } else if (width < 420) {
        itemsToShow = 3;
    } else if (width < 520) {
        itemsToShow = 4;
    } else if (width < 620) {
        itemsToShow = 5;
    } else if (width < 640) {
        itemsToShow = 4;
    } else if (width < 720) {
        itemsToShow = 5;
    } else if (width < 768) {
        itemsToShow = 6;
    } else if (width < 860) {
        itemsToShow = 5;
    } else {
        itemsToShow = 6;
    }

    visibleBrands.value = limitedBrands.value.slice(0, itemsToShow);
}

const form = useForm({
    first_name: null,
    last_name: null,
    email: null,
    phone_number: null,
    subject: "algemeen",
    message: null,
    contact: null,
    terms: false,
})

const saveButton = ref(null);

const contactFormSendSuccess = ref(false);
const contactFormSendError = ref(false);

function submit() {
    saveButton.value.setSaving(true);

    form.post('/contact', {
        preserveScroll: true,
        onSuccess: () => {
            contactFormSendSuccess.value = true;
            if (saveButton.value) {
                saveButton.value.setSaving(false);
            }
        },
        onError: () => {
            if (!form.hasErrors) {
                contactFormSendError.value = true;
            }

            if (saveButton.value) {
                saveButton.value.setSaving(false);
            }
        }
    });
}

function goToBrand(vehicleBrand) {
    const filterParams = {
        brand: vehicleBrand,
    };

    setParams(filterParams);
}

function setParams(params) {
    localStorage.setItem('filterParams', JSON.stringify(params));

    router.visit('/aanbod');
}

const params = new URLSearchParams(window.location.search);
const subject = params.get('subject')?.toLowerCase();
if (subject) {
    form.subject = subject;
    //create a template message for asking for a proefrit
    const vehicle = params.get('vehicle');
    if (subject === 'proefrit' && vehicle) {
        form.message = `Beste Zwagers Automotive, \n\nIk zou graag een proefrit willen maken in de ${vehicle}. \n\nMet vriendelijke groet, \n\n`;
    }
}
</script>
<template>

    <div class="flex flex-col bg-black -space-y-40">
        <div id="hero" class="h-full text-white">
            <div class="h-screen min-h-[768px] lg:h-[80vh] flex flex-col max-h-[1200px]">
                <img :src="'/img/team/zwagers_automotive_team_header_53.webp'" class="opacity-70 absolute w-full h-full min-h-[768px] lg:h-[80vh] max-h-[1200px] aspect-video object-cover object-[50%_20%]" />
                <div class="z-10 flex justify-center h-full w-full min-h-[768px]">
                    <div class="w-11/12 px:0 md:px-6 xl:px-0 h-5/6 max-w-6xl">
                        <div class="flex flex-col gap-10 h-full justify-start lg:justify-center pt-40 lg:pt-0">
                            <h1 class="text-shadow w-full md:w-9/12 xl:w-8/12">Twee zwagers, <br>Eigen specialisatie</h1>
                            <p class="text-shadow sm:block w-full lg:w-6/12 2xl:w-6/12">
                                Twee zwagers, beiden met hun eigen specialisatie, besloten hun krachten te bundelen. De één, altijd al handig met motoren en techniek, 
                                is specialist in diagnoses en storingen opzoeken en een ervaren APK-keurmeester. De ander, met een neus voor mooie auto’s...<br><span class="font-semibold cursor-pointer text-tan hover:text-tanhover underline"><a href="#team">Lees meer</a></span>
                            </p>
                            <div class="flex sm:flex-row flex-col gap-6 mt-auto sm:mt-0">
                                <Button href="https://wa.me/+31617328160" type="href" target="_blank"
                                    class="primary-button" :useInertia="false">
                                    <font-awesome-icon :icon="['fab', 'whatsapp']" class="h-5 w-5" />
                                    Whatsapp
                                </Button>
                                <Button href="#contactform" type="href" class="secondary-white-button">
                                    Contact
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <section id="sub-hero"
            class="flex justify-center pt-8 md:pt-20 lg:pt-28 pb-4 z-20 bg-gradient-to-b from-transparent via-black via-35% to-black text-white">
            <div class="w-11/12 px:0 md:px-6 xl:px-0 max-w-6xl">
                <div class="flex flex-col md:grid grid-cols-3 w-full justify-between gap-8">
                    <div class="flex justify-center sm:justify-center md:justify-start">
                        <Button href="tel:+31617328160" type="href"
                            class="group text-white hover:text-tanhover flex flex-col items-center"
                            :useInertia="false">
                            <div class="flex items-center gap-4 transform group-hover:-translate-y-0.5 duration-500">
                                <font-awesome-icon class="h-8" :icon="['far', 'phone']" />
                                <span
                                    class="text-center text-3xl font-semibold tracking-tight lg:text-4xl items-center">Telefoon</span>
                            </div>
                            <span class="text-center text-base/7 text-gray-400">+31(0)617328160</span>
                        </Button>
                    </div>
                    <div class="flex justify-center sm:justify-center">
                        <Button href="mailto:info@zwagersautomotive.nl" type="href"
                            class="group text-white hover:text-tanhover flex flex-col items-center"
                            :useInertia="false">
                            <div class="flex items-center gap-4 transform group-hover:-translate-y-0.5 duration-500">
                                <font-awesome-icon class="h-8" :icon="['far', 'envelope']" />
                                <span
                                    class="text-center text-3xl font-semibold tracking-tight lg:text-4xl items-center">E-mail</span>
                            </div>
                            <span class="text-center text-base/7 text-gray-400">info@zwagersautomotive.nl</span>
                        </Button>
                    </div>
                    <div class="flex justify-center sm:justify-center md:justify-end">
                        <Button href="https://maps.app.goo.gl/JmCJRMgToeovnWfb7" target="_blank" type="href"
                            class="group text-white hover:text-tanhover flex flex-col items-center"
                            :useInertia="false">
                            <div class="flex items-center gap-4 transform group-hover:-translate-y-0.5 duration-500">
                                <font-awesome-icon class="h-8" :icon="['far', 'car-building']" />
                                <span
                                    class="text-center text-3xl font-semibold tracking-tight lg:text-4xl items-center">Locatie</span>
                            </div>
                            <span class="text-center text-base/7 text-gray-400">Ambachtstraat 3F, 7622 AS Borne</span>
                        </Button>
                    </div>
                </div>
            </div>
        </section>
    </div>

    <main class="text-white">
        <section id="ideale-auto" class="bg-black flex justify-center pt-8 md:pt-20 lg:pt-28">
            <div class="w-11/12 px:0 md:px-6 xl:px-0 max-w-6xl flex flex-col gap-12">
                <div class="text-shadow w-full md:w-9/12 xl:w-8/12">
                    <p>Jouw ideale auto</p>
                    <h1 class="text-balance">Wij zoeken de auto die bij je past</h1>
                </div>
                <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 mb-20">
                    <div
                        class="flex flex-col gap-4 bg-white rounded-xl shadow-lg p-6 text-black scale-100 hover:scale-105 transition duration-500 group">
                        <font-awesome-icon
                            class="w-8 h-8 md:w-12 md:h-12 mb-4 text-timber transition duration-500"
                            :icon="['fas', 'phone-volume']" />
                        <h6
                            class="font-semibold text-lg md:text-2xl group-hover:text-timber transition duration-500">
                            Contact</h6>
                        <p class="text-sm md:text-base text-pretty">
                            Neem met ons contact op en specificeer jou
                            wensen, laat ons weten waar je naar op zoek
                            bent.
                        </p>
                    </div>
                    <div
                        class="flex flex-col gap-4 bg-white rounded-xl shadow-lg p-6 text-black scale-100 hover:scale-105 transition duration-500 group">
                        <font-awesome-icon
                            class="w-8 h-8 md:w-12 md:h-12 mb-4 text-timber transition duration-500"
                            :icon="['fas', 'car-building']" />
                        <h6
                            class="font-semibold text-lg md:text-2xl group-hover:text-timber transition duration-500">
                            Uitgebreid aanbod</h6>
                        <p class="text-sm md:text-base text-pretty">
                            Wij hebben een uitgebreid netwerk en kunnen op basis van jouw wensen gericht op zoek gaan naar de juiste auto, ook als deze niet direct bij ons aanwezig is.
                        </p>
                    </div>
                    <div
                        class="flex flex-col gap-4 bg-white rounded-xl shadow-lg p-6 text-black scale-100 hover:scale-105 transition duration-500 group">
                        <font-awesome-icon
                            class="w-8 h-8 md:w-12 md:h-12 mb-4 text-timber transition duration-500"
                            :icon="['fas', 'garage-open']" />
                        <h6
                            class="font-semibold text-lg md:text-2xl group-hover:text-timber transition duration-500">
                            Gevonden</h6>
                        <p class="text-sm md:text-base text-pretty">
                            Wanneer we binnen ons aanbod gevonden hebben
                            waar jij naar zoekt maken we deze voor je klaar.
                        </p>
                    </div>
                    <div
                        class="flex flex-col gap-4 bg-white rounded-xl shadow-lg p-6 text-black scale-100 hover:scale-105 transition duration-500 group">
                        <font-awesome-icon
                            class="w-8 h-8 md:w-12 md:h-12 mb-4 text-timber transition duration-500"
                            :icon="['fas', 'carpool']" />
                        <h6
                            class="font-semibold text-lg md:text-2xl group-hover:text-timber transition duration-500">
                            Ontvangst</h6>
                        <p class="text-sm md:text-base text-pretty">
                            Wanneer wij je auto hebben gecontroleerd en
                            klaargemaakt is het tijd om jouw auto te
                            ontvangen!
                        </p>
                    </div>
                </div>
            </div>
        </section>
        <section id="merken" class="bg-white text-black flex justify-center pt-16 md:pt-32 lg:pt-40">
            <div class="w-11/12 px:0 md:px-6 xl:px-0 max-w-6xl space-y-12 lg:inline-flex lg:space-y-0 lg:space-x-20">
                <div class="flex flex-col gap-6 lg:h-full lg:justify-center">
                    <h2 class="font-bold">Wij bieden diverse automerken aan</h2>
                    <p>Onze expertise is dan ook
                        niet gefocused op een merk maar op een groot aanbod voor onze klanten.</p>
                </div>
                <div id="brand-container"
                    class="h-auto flex lg:min-w-[500px] flex-row lg:grid grid-cols-3 gap-3 sm:gap-4 lg:gap-6 justify-center lg:justify-normal">
                    <div v-for="brand in visibleBrands" :key="brand.id"
                        :class="['merk-box', 'group p-2 sm:p-3 md:p-4 aspect-square hover:scale-105 transition duration-500']">
                        <img :src="brand.src" :alt="brand.label" class="w-32 h-auto max-h-20 object-contain text-white" />
                    </div>
                </div>
            </div>
        </section>
        <section id="team"
            class="bg-white text-black flex justify-center pt-16 md:pt-32 lg:pt-40 pb-8 md:pb-20 lg:pb-28">
            <div class="w-11/12 px:0 md:px-6 xl:px-0 max-w-6xl">
                <div class="space-y-12">
                    <div class="space-y-3 text-start sm:text-center">
                        <p class="font-semibold">Passie voor auto’s</p>
                        <h2 class="font-bold">Ontmoet ons team</h2>
                        <p>Zwagers Automotive is ontstaan uit familieband én een gedeelde passie voor auto’s</p>
                    </div>
                    <div class="flex flex-col gap-4">
                        <div class="grid grid-cols-1 max-w-2xl mx-auto gap-4 sm:gap-8 justify-items-center">
                            <img class="w-full h-full max-h-80 max-w-80 rounded-2xl object-cover mt-8 sm:mt-0 object-[50%_20%]"
                                :src="'/img/team/zwagers_automotive_team_header_41.webp'" />
                        </div>
                    </div>
                    <p class="text-start sm:text-center max-w-3xl mx-auto">
                        Twee zwagers, beiden met hun eigen specialisatie, besloten hun krachten te bundelen. De één, 
                        altijd al handig met motoren en techniek, is specialist in diagnoses en storingen opzoeken en een ervaren APK-keurmeester. <br><br>
                        De ander, met een neus voor mooie auto’s en scherpe deals, richt zich op inkoop en verkoop. 
                        Samen ontdekten we dat we meer konden bereiken door onze kennis en ervaring te combineren en zo werd Zwagers Automotive geboren. <br><br>
                        Onze samenwerking gaat verder dan alleen werk het is een echte familiezaak. We vullen elkaar perfect aan en leren elke dag van elkaar. 
                        Dit merk je ook in de manier waarop we met onze klanten omgaan: we luisteren, denken met je mee en geven eerlijk advies. 
                        Of je nu op zoek bent naar een zorgvuldig geselecteerde occasion of een auto wilt laten onderhouden, 
                        wij begeleiden je van begin tot eind. <br><br>Het mooiste moment voor ons is wanneer iemand de weg op rijdt in zijn of haar nieuwe auto, 
                        met een glimlach van oor tot oor. Dat gevoel, dat vertrouwen en die tevredenheid van onze klanten, 
                        daar doen we het voor. Bij Zwagers Automotive draait alles om kwaliteit, 
                        betrouwbaarheid en persoonlijke aandacht precies zoals het zou moeten zijn bij een familiebedrijf.
                    </p>
                </div>
            </div>
        </section>
        <Faq id="lease" />
        <section id="contactform" class="flex flex-col items-center text-black py-10 md:py-20 lg:py-28 gap-28">
            <div class="w-11/12 px:0 md:px-6 xl:px-0 max-w-6xl">
                <div class="flex flex-col md:grid grid-cols-3 w-full justify-between gap-8">
                    <div class="flex justify-center sm:justify-center md:justify-start">
                        <Button href="tel:+31617328160" type="href"
                            class="group text-black hover:text-tanhover flex flex-col items-center"
                            :useInertia="false">
                            <div class="flex items-center gap-4 transform group-hover:-translate-y-0.5 duration-500">
                                <font-awesome-icon class="h-8" :icon="['far', 'phone']" />
                                <span
                                    class="text-center text-3xl font-semibold tracking-tight lg:text-4xl md:items-center">Telefoon</span>
                            </div>
                            <span class="text-center text-base/7 text-gray-400">+31(0)617328160</span>
                        </Button>
                    </div>
                    <div class="flex justify-center sm:justify-center">
                        <Button href="mailto:info@zwagersautomotive.nl" type="href"
                            class="group text-black hover:text-tanhover flex flex-col items-center"
                            :useInertia="false">
                            <div class="flex items-center gap-4 transform group-hover:-translate-y-0.5 duration-500">
                                <font-awesome-icon class="h-8" :icon="['far', 'envelope']" />
                                <span
                                    class="text-center text-3xl font-semibold tracking-tight lg:text-4xl items-center">E-mail</span>
                            </div>
                            <span class="text-center text-base/7 text-gray-400">info@zwagersautomotive.nl</span>
                        </Button>
                    </div>
                    <div class="flex justify-center sm:justify-center md:justify-end">
                        <Button href="https://maps.app.goo.gl/JmCJRMgToeovnWfb7" target="_blank" type="href"
                            class="group text-black hover:text-tanhover flex flex-col items-center"
                            :useInertia="false">
                            <div class="flex items-center gap-4 transform group-hover:-translate-y-0.5 duration-500">
                                <font-awesome-icon class="h-8" :icon="['far', 'car-building']" />
                                <span
                                    class="text-center text-3xl font-semibold tracking-tight lg:text-4xl items-center">Locatie</span>
                            </div>
                            <span class="text-center text-base/7 text-gray-400">Ambachtstraat 3F, 7622 AS Borne</span>
                        </Button>
                    </div>
                </div>
                <form @submit.prevent="submit" class="mt-10 md:mt-20 relative">
                    <div class="mt-4 grid sm:grid-cols-12 text-sm font-normal text-gray-900 gap-5">
                        <div class="col-span-full sm:col-span-6">
                            <Input v-model="form.first_name" label="Voornaam" placeholder="Vul je voornaam in" required
                                :error="form.errors.first_name" inputId="firstName" />
                        </div>
                        <div class="col-span-full sm:col-span-6">
                            <Input v-model="form.last_name" label="Achternaam" placeholder="Vul je achternaam in"
                                required :error="form.errors.last_name" inputId="lastName" />
                        </div>
                        <div class="col-span-full sm:col-span-6">
                            <Input v-model="form.email" label="E-mailadres" placeholder="Vul je e-mailadres in"
                                type="email" required :error="form.errors.email" inputId="email" />
                        </div>
                        <div class="col-span-full sm:col-span-6">
                            <Input v-model="form.phone_number" label="Telefoonnummer" type="tel"
                                placeholder="Vul je telefoonnummer in" :error="form.errors.phone_number"
                                inputId="phoneNumber" />
                        </div>
                        <div class="col-span-full">
                            <Select v-model="form.subject" label="Onderwerp" :options="subjects" valueName="label"
                                valueId="id" :error="form.errors.subject" inputId="subject" />
                        </div>
                        <div class="col-span-full">
                            <Textarea v-model="form.message" label="Bericht" required :error="form.errors.message"
                                inputId="message" />
                        </div>
                        <div class="w-full flex flex-row flex-wrap justify-between col-span-full gap-y-2">
                            <Checkbox v-model="form.terms" :error="form.errors.terms"
                                label="Ik ga akkoord met de voorwaarden" inputId="terms" />
                            <SaveButton class="primary-button" text="Bericht versturen"
                                savingText="Bericht aan het versturen..." ref="saveButton" />
                        </div>
                    </div>
                    <div v-if="contactFormSendSuccess || contactFormSendError"
                        class="absolute bg-black w-full h-full top-0 flex items-center justify-center rounded-lg text-white p-4">
                        <p v-if="contactFormSendSuccess">Je bericht is succesvol verzonden!</p>
                        <p v-if="contactFormSendError">Er is een fout opgetreden bij het verzenden van je bericht.
                            Controleer de invoer en probeer het opnieuw.</p>
                    </div>
                </form>
            </div>
        </section>
    </main>
    <Subfooter />
</template>
